import React from 'react';

import {images} from '../../constants';

import './Info.css';

const Info = () => (
  <div className='app__aboutus app__bg flex__center section__padding' id='about'>
    <div className='app__aboutus-overlay flex__center'>
      <img src={images.D} alt="d letter"></img>

    </div>
    <div className='app__aboutus-content flex__center'>
      <div className='app__aboutus-content_about'>
        <h1 className='headtext__cormorant'>Gift Cards</h1>
        <img src={images.spoon} alt='about_spoon' className='spoon_img'/>
        <p className='p__opensans'>We provide gift cards in any desired amount</p>
        <p className='p__opensans'>Gift Cards are available: </p>
        <p className='p__opensans'>~ In Store</p>
        <p className='p__opensans'>~ Phone Call</p>
        <p className='p__opensans'>We Accept cash or credit payments</p>

      </div>

    <div className='app__aboutus-content_divider flex__center'>
      <img src={images.divider} alt='about_divider'/>
    </div>

    <div className='app__aboutus-content_hours'>
        <h1 className='headtext__cormorant'>Gratuity</h1>
        <img src={images.spoon} alt='about_spoon' className='spoon_img'/>
        <p className='p__opensans'>Gratuities are appreciated in:</p>
        <p className='p__opensans'>~ Zelle</p>
        <p className='p__opensans'>~ Venmo</p>
        <p className='p__opensans'>~ Cash</p>
        <p className='p__opensans'>We unfortunately do not accept credit tip</p>
      </div>
    </div>
  </div>
);

export default Info;
